<template>
    <div class="pp-tab">
        <div ref="header-wrap" class="pp-tab__header-wrap">
            <div ref="header" 
                :class="[
                    'pp-tab__header',
                    scroll ? 'is-scroll' : 'is-flex',
                ]" 
                :style="headerStyle">
                <div v-for="(item, index) in tabs" :key="index"
                    :class="[
                        'pp-tab__header-item',
                        {'is-active': value === item.name,}
                    ]"
                    :style="{
                        width: width, 
                        flex: width ? '' : 1,
                    }"
                    @click="active(item.name)">
                    <i v-if="item.icon" :class="item.icon"></i>
                    <!-- <span>{{item.label}}</span> -->
                    {{item.label}}
                </div>
                <i class="pp-tab__header-line" :style="lineStyle"></i>
            </div>
        </div>
        <div class="pp-tab__body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import Dom from '../../../src/util/dom.js'

/**
 * 标签页
 * @param {String} value v-model绑定值
 * @param {Boolean} scroll 标签头部是否可滚动 scroll ? float布局 : flex布局
 * @param {String} width 标签项宽度
 * @event change 标签页激活项变动时触发
 */
export default {
    name: 'pp-tab',
    props: {
        value: String,
        scroll: Boolean,
        width: String,
    },
    data: function() {
        return {
            tabs: [],
            lineStyle: {
                width: 0,
                left: 0,
            },
            headerStyle: {
                width: '100%',
            },
            scrollTimer: null,
        };
    },
    watch: {
        value: function(n) {
            this.setLineStyle(n)
        },
    },
    mounted: function() {
        this.scroll 
            ? this.setHeaderStyle() 
            : this.setLineStyle(this.value)
    },
    methods: {
        active: function(name) {
            this.$emit('input', name)
            this.$emit('change', name)
        },

        setLineStyle: function(name) {
            this.$nextTick(()=> {
                let el = this.$el.querySelector('.is-active');
                
                this.$set(this.lineStyle, 'width', el.offsetWidth + 'px')
                this.$set(this.lineStyle, 'left', el.offsetLeft + 'px')
                
                this.setHeaderScroll(el)
            })
        },

        setHeaderStyle: function() {
            this.$nextTick(()=> {
                let els = this.$el.querySelectorAll('.pp-tab__header-item');
                let len = els.length;
                let width = 0;
                
                while(len--) {
                    width += els[len].getBoundingClientRect().width;
                }

                this.headerStyle.width = Math.ceil(width) + 'px'
                
                this.setLineStyle(this.value)
            })
        },

        setHeaderScroll: function(el) {
            if(!Dom.isElementInViewPoint(el)) {
                this.$refs['header-wrap'].scrollLeft = el.offsetLeft - 20; //hack Dom.scrollCrossSmooth() in future
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.pp-tab__header-item {
    cursor: pointer;
}
</style>
